/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import { Container, Form, Row, Button, Col } from 'react-bootstrap'
import InputForm from './InputForm'
import CheckForm from './CheckForm'
import RadioButtonForm from './RadioButtonForm'
import ModalQuit from '../ModalQuit'
import InvertColorsOutlinedIcon from '@mui/icons-material/InvertColorsOutlined'
import { nanoid } from 'nanoid'
import CommonAlert from './CommonAlert'
import AllModalsFooter from '../assets/AllModalsFooter'
import { SaveButtonGreen, SaveCurrentDataButton } from '../assets/BasicButtons'
import { createData } from './functionsForm'
import { isEqual } from 'lodash-es'

export default class Form_Six extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      language: 'rus',
      dataValue: [],
      // id: 3,
      maxId: 12,
      nameForm: 'Six',
      dataOnServer: [],
      dataFromServer: [],
      lengthDataFromServer: 0,
      base: [],
      show: false,
      show1: false,
      showQuit: false,
      showContent: true,
      previousState: [],
      savedDataMessage: false,
      dataBeenSaved: false
    }

    this.doChangeValue = this.doChangeValue.bind(this)
    this.handleClickSave = this.handleClickSave.bind(this)
    this.handleClickShadow = this.handleClickShadow.bind(this)
    this.doChangeVisionBlock = this.doChangeVisionBlock.bind(this)
    this.renderChoice = this.renderChoice.bind(this)
    this.doEmpty = this.doEmpty.bind(this)

    this.doQuitWithSave = this.doQuitWithSave.bind(this)
    this.doQuitWithoutSave = this.doQuitWithoutSave.bind(this)
    this.closeQuitModal = this.closeQuitModal.bind(this)
    this.hideContent = this.hideContent.bind(this)
    this.setCompanyName = this.setCompanyName.bind(this)
    this.compare = this.compare.bind(this)
    this.smartWindowFunction = this.smartWindowFunction.bind(this)
    this.saveDataWithNotification = this.saveDataWithNotification.bind(this)
  }

  saveDataWithNotification() {
    this.handleClickSave()

    this.setState({
      savedDataMessage: true,
      dataBeenSaved: true
    })
    setTimeout(() => {
      this.setState({
        savedDataMessage: false
      })
    }, 2000)
  }

  hideContent() {
    this.setState({ showContent: false })
  }

  setCompanyName() {
    if (this.props.companyName && this.props.companyName.length > 0) {
      this.setState({
        companyName: this.props.companyName
      })
    }
  }

  closeQuitModal() {
    this.setState({
      showQuit: false
    })
  }

  //*Пустышка
  doEmpty() {}

  //* меняем видимость блока при выборе ДА / НЕТ
  doChangeVisionBlock(data, id) {
    console.log(data) //test
    console.log(id) //test

    if (+id === 4) {
      if (data === 'Да') this.setState({ show: true })
      if (data === 'Нет' || data === '') this.setState({ show: false })
    }

    if (+id === 8) {
      if (data === 'Да') this.setState({ show1: true })
      if (data === 'Нет' || data === '') this.setState({ show1: false })
    }
  }

  renderChoice() {
    if (this.props.data[4]) if (this.props.data[4].value === 'Да') this.setState({ show: true })
    if (this.props.data[8]) if (this.props.data[8].value === 'Да') this.setState({ show1: true })
  }

  //запуск выхода из формы
  handleClickShadow() {
    this.setState({ showQuit: true })
  }

  //выход с сохранением
  doQuitWithSave() {
    this.setState({ showQuit: false })
    this.handleClickSave()
    this.props.onChangeView('Six')
  }
  //выход без сохранения
  doQuitWithoutSave() {
    this.setState({ showQuit: false })
    this.props.onChangeView('Six')
  }

  //*формируем данные в массив объектов для отправки на сервер
  handleClickSave() {
    let data = this.state.dataOnServer

    for (let i = 0; i <= this.state.maxId; i++) {
      //todo создаем позицию с пустым объектом
      data[i] = { id: '', fid: '', description: '', information: '', value: '' }

      //todo заполняем объект данными с сервера
      this.state.dataFromServer.forEach((dataD) => {
        if (+dataD.id === i) {
          data[i] = { id: dataD.id, fid: dataD.fid, description: dataD.description, information: dataD.information, value: dataD.value }
        }
      })
      //todo заполняем объект данными с формы
      this.state.dataValue.forEach((dataE) => {
        if (+dataE.id === i) {
          data[i] = { id: dataE.id, fid: dataE.fid, description: dataE.description, information: dataE.information, value: dataE.value }
        }
      })
    }
    this.setState({ dataOnServer: data }) //todo проверка на наличие данных на сервере
    if (this.state.lengthDataFromServer < 1) {
      console.log('CREATE DATA')
      this.props.onCreateDataServer(data, 'Six', localStorage.getItem('idUser'))
    } else {
      console.log('UPDATE DATA')
      this.props.onUpdateDataOnServer(data, 'Six', localStorage.getItem('idUser'))
    }
    setTimeout(() => {
      console.log(this.state.dataOnServer)
    }) //test
    // this.handleClickShadow();
  }

  //* данные с полей формы, формируются в массив объектов
  doChangeValue(data) {
    console.log(data) //test
    this.setState({ dataValue: [...this.state.dataValue, data] })
    setTimeout(() => {
      console.log(this.state.dataValue)
    }) //test
    this.setState({
      dataBeenSaved: false
    })
  }

  compare() {
    const prev = this.state.previousState
    const curr = createData(this.state.dataOnServer, this.state.maxId, this.state.dataFromServer, this.state.dataValue)

    const isStateEqual = isEqual(prev, curr)
    if (isStateEqual) {
      return true
    }
    return false
  }

  smartWindowFunction() {
    const isStateEqual = this.compare()
    const { dataBeenSaved, dataValue } = this.state
    if (isStateEqual || dataBeenSaved || ( dataValue.length === 0)) {
      this.props.onChangeView('Six')
    } else {
      this.handleClickShadow()
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ dataFromServer: this.props.data, lengthDataFromServer: this.props.lengthDataFromServer })
      this.renderChoice()
      // console.log('DATA on dataFromServer');//test
      console.log(this.props.data) //test
    }, 1000)

    this.setCompanyName()

    if (this.props.data.length) {
      const previousState = JSON.parse(JSON.stringify(this.props.data))
      this.setState({ previousState })
    }
  }

  render() {
    const view = this.props.view
    this.value = this.props.data
    const viewQuest = this.props.viewQuest

    const inReadMode = this.props.innFromUniversalTable === null || this.props.innFromUniversalTable === '' || this.props.innFromUniversalTable === undefined

    return (
      <>
        {inReadMode && <>{this.state.showQuit ? <ModalQuit onQuitWithSave={this.doQuitWithSave} onQuitWithoutSave={this.doQuitWithoutSave} closeQuitModal={this.closeQuitModal} /> : ''}</>}

        {this.state.showContent && (
          <div className='modal_window' style={{ display: view ? 'block' : 'none' }}>
            <div
              className={viewQuest ? 'shadow_form' : 'shadow_form_off'}
              // onClick={this.handleClickShadow}
              onClick={this.smartWindowFunction}
            ></div>
            <Form className={viewQuest ? 'form_main' : 'form_main_view'}>
              <CommonAlert
                inReadMode={inReadMode}
                handleClickHeader={this.handleClickHeader}
                // handleClickShadow={this.handleClickShadow}
                handleClickShadow={this.smartWindowFunction}
                hideContent={this.hideContent}
                icon={<InvertColorsOutlinedIcon fontSize='large' className='icon_primary' />}
                companyName={this.state.companyName}
                sectionName='Окраска поверхностей'
              />
              <div>
                <Container className='form_container'>
                  <Form.Group>
                    <Row> &nbsp; </Row>
                    <Row>
                      <Col>Подготовка поверхностей:</Col>
                    </Row>

                    <Row>
                      <CheckForm
                        name={nanoid()}
                        id={1}
                        width={8}
                        show={!inReadMode && !this.value[1] ? false : true}
                        placeholder='Пескоструйная обработка'
                        description='Работа с ЛКМ, подготовка поверхносей'
                        value={this.value[1] ? this.value[1].value : ''}
                        onChangeValue={this.doChangeValue}
                        onChangeVisionBlock={this.doEmpty}
                        nameForm={this.state.nameForm}
                        readOnly={!inReadMode}
                      />
                    </Row>
                    <Row>
                      <CheckForm
                        name={nanoid()}
                        id={2}
                        width={8}
                        show={!inReadMode && !this.value[2] ? false : true}
                        placeholder='Дробеструйная обработка'
                        description='Работа с ЛКМ, подготовка поверхносей'
                        value={this.value[2] ? this.value[2].value : ''}
                        onChangeValue={this.doChangeValue}
                        onChangeVisionBlock={this.doEmpty}
                        nameForm={this.state.nameForm}
                        readOnly={!inReadMode}
                      />
                    </Row>
                    <Row>
                      <CheckForm
                        name={nanoid()}
                        id={3}
                        width={8}
                        show={!inReadMode && !this.value[3] ? false : true}
                        placeholder='Механическая зачистка'
                        description='Работа с ЛКМ, подготовка поверхносей'
                        value={this.value[3] ? this.value[3].value : ''}
                        onChangeValue={this.doChangeValue}
                        onChangeVisionBlock={this.doEmpty}
                        nameForm={this.state.nameForm}
                        readOnly={!inReadMode}
                      />
                    </Row>
                  </Form.Group>
                  {/* <Row> &nbsp; </Row> */}
                  <Form.Group>
                    <Row>
                      <RadioButtonForm
                        id={4}
                        width={12}
                        show={true}
                        title='Наличие камеры нанесения ЛКМ:'
                        label1='Да'
                        label2='Нет'
                        placeholder='Работа с ЛКМ, камера нанесения'
                        description='Окраска поверхностей'
                        value={this.value[4] ? this.value[4].value : ''}
                        onChangeValue={this.doChangeValue}
                        onChangeVisionBlock={this.doChangeVisionBlock}
                        nameForm={this.state.nameForm}
                        readOnly={!inReadMode}
                      />
                    </Row>
                    <Row> &nbsp; </Row>
                    <Form.Group style={{ display: this.state.show ? 'block' : 'none' }}>
                      <Row>
                        <Col>Максимальные габариты окрашиваемого изделия:</Col>
                      </Row>
                      <Row>
                        <InputForm
                          id={5}
                          width={3}
                          show={!inReadMode && !this.value[5] ? false : true}
                          verify='number'
                          label='Длина, мм'
                          fontSize={'12px'}
                          placeholder='Длина, мм'
                          description='Работа с ЛКМ, нанесение'
                          value={this.value[5] ? this.value[5].value : ''}
                          onChangeValue={this.doChangeValue}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                        <InputForm
                          id={6}
                          width={3}
                          show={!inReadMode && !this.value[6] ? false : true}
                          verify='number'
                          label='Ширина, мм'
                          fontSize={'12px'}
                          placeholder='Ширина, мм'
                          description='Работа с ЛКМ, нанесение'
                          value={this.value[6] ? this.value[6].value : ''}
                          onChangeValue={this.doChangeValue}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                        <InputForm
                          id={7}
                          width={3}
                          show={!inReadMode && !this.value[7] ? false : true}
                          verify='number'
                          label='Высота, мм'
                          fontSize={'12px'}
                          placeholder='Высота, мм'
                          description='Работа с ЛКМ, нанесение'
                          value={this.value[7] ? this.value[7].value : ''}
                          onChangeValue={this.doChangeValue}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                        <InputForm
                          id={8}
                          width={3}
                          show={!inReadMode && !this.value[8] ? false : true}
                          verify='number'
                          label='Масса изделия, тн'
                          fontSize={'12px'}
                          placeholder='Масса изделия, тн'
                          description='Работа с ЛКМ, нанесение'
                          value={this.value[8] ? this.value[8].value : ''}
                          onChangeValue={this.doChangeValue}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                      </Row>
                    </Form.Group>
                  </Form.Group>

                  <Row>&nbsp;</Row>
                </Container>
                <AllModalsFooter
                  footerContent={
                    inReadMode && (
                      //     <SaveButtonGreen
                      //     handleSaveClick={this.handleClickSave}
                      //     needDisable={false}
                      //     saveButtonText='Сохранить'
                      //   />
                      <SaveCurrentDataButton
                        handleSaveClick={this.saveDataWithNotification}
                        needDisable={false}
                        savedDataMessage={this.state.savedDataMessage}
                        buttonTextDefault={'Сохранить'}
                        buttonTextSaved={'Данные сохранены'}
                        needCustomIcon={false}
                      />
                    )

                    // <Button variant="success" onClick={this.handleClickSave}> Сохранить</Button>
                  }
                />
              </div>
            </Form>
          </div>
        )}
      </>
    )
  }
}
